// @greenlight-spec: 28-it-dashboard-ui.md
export const ACTIVE_POLL_MS = 5_000;
export const STATUS_POLL_MS = 15_000;

export const liveQueryOptions = {
  refetchInterval: STATUS_POLL_MS,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: 'always' as const,
};

export const metricsQueryOptions = {
  ...liveQueryOptions,
  staleTime: 60_000,
  refetchInterval: 60_000,
};

export function isWorking(status: string | null | undefined): boolean {
  return (
    status === 'registering' ||
    status === 'building' ||
    status === 'running' ||
    status === 'deploying' ||
    status === 'queued_for_deletion'
  );
}

export function statusPollInterval(statuses: readonly (string | null | undefined)[]): number {
  return statuses.some(isWorking) ? ACTIVE_POLL_MS : STATUS_POLL_MS;
}

export function isTransientQueryError(error: unknown): boolean {
  if (typeof error !== 'object' || error === null || !('status' in error)) return true;
  return typeof error.status === 'number' && (error.status >= 500 || error.status === 429);
}
